import type { CalcField, DataSourceSummary, SourceMetadata, CreateFieldInput, UpdateFieldInput } from './types'

async function json(res: Response) {
  const body = await res.json().catch(() => ({}))
  if (!res.ok || body?.error) throw new Error(body?.error || `HTTP ${res.status}`)
  return body.data
}

export async function listFields(projectId: number, dataSourceId: number): Promise<CalcField[]> {
  return json(await fetch(`/api/calculated-fields?dataSourceId=${dataSourceId}&projectId=${projectId}`, { credentials: 'include' }))
}

export async function listDataSources(projectId: number): Promise<DataSourceSummary[]> {
  return json(await fetch(`/api/data-sources/clients/${projectId}/data-sources`, { credentials: 'include' }))
}

export async function fetchMetadata(sourceType: string): Promise<SourceMetadata> {
  const data = await json(await fetch(`/api/query/metadata/${sourceType}`, { credentials: 'include' }))
  return { metrics: data.metrics ?? [], dimensions: data.dimensions ?? [] }
}

export async function createField(input: CreateFieldInput): Promise<CalcField> {
  return json(await fetch('/api/calculated-fields', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  }))
}

export async function updateField(id: number, input: UpdateFieldInput): Promise<CalcField> {
  return json(await fetch(`/api/calculated-fields/${id}`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  }))
}

export async function deleteField(id: number, projectId: number): Promise<void> {
  await json(await fetch(`/api/calculated-fields/${id}?projectId=${projectId}`, { method: 'DELETE', credentials: 'include' }))
}
